import React, { useContext } from 'react';
import { urls } from '../..';
import InfoMessage from '.././InfoMessage';
import { filterSportsFromSearchResults } from '../../data/utils/filterSportsFromSearchResults';
import { iconCategoryCssClass } from '../../data/utils/iconCategoryCssClass';
import { getLabel } from '../../data/labels';
import { usePrematchData } from '../../prematch/PrematchDataProvider';
import { useSearchData } from './SearchDataProvider';
import { XRouterNavigateContext } from '../seo/xrouter/XRouterNavigateContext';

export default function PrematchResults(props) {
    const xrouterNavigateContext =  useContext(XRouterNavigateContext);
    const searchData = useSearchData();
    const prematchData = usePrematchData();
    const sports = filterSportsFromSearchResults(searchData, props.search);
   
    if (sports.length === 0) {
        return (
            <div className="my-2">
                <InfoMessage message={getLabel('general.no_events')} />
            </div>
        );
    }

    // Sort sports by ranking
    try {
        sports.sort((a, b) => {
            const rankingA = prematchData.sportById[a.id].ranking;
            const rankingB = prematchData.sportById[b.id].ranking;
            return rankingA - rankingB;
        });
    } catch(e) {
        console.error(e);
    }

    function openEvent(e) {
        const tournamentUniqueId = `${e.sportRef}_${e.categoryRef}_${e.tournamentRef}`;
        xrouterNavigateContext.navigate(`${urls.base}/${urls.prematch.base}/${urls.prematch.tournament}/${tournamentUniqueId}/${urls.prematch.event}/${e.id}`, {data:e,state: e});
        props.toggle();
    }
    
    return (
        <>
            {sports.map(s =>
                s.tournaments.map(t =>
                    t.events.map(e => {
                        const iconClass = prematchData.sportById[e.sportRef]?.categoryById[e.categoryRef]?.iconClass ?? null;
                        const categoryIcon = iconCategoryCssClass(e.sportRef, e.categoryRef, iconClass);
                        const desc = `${e.sportDesc} - ${e.tournamentDesc}`;
                        return (
                            <div key={e.id} className="p-1 bg-cs1 flex flex-col justify-center border-b border-b-cs7" onClick={() => openEvent(e)}>
                                <div className="grid grid-cols-12">
                                    <div className="col-start-1 col-end-2 h-full flex items-center">
                                        <div className="p-1 flex flex-col justify-center border border-cs-9 rounded-md">
                                            <span className={"my-auto inline-block w-[24px] h-[24px] categoryIcon " + categoryIcon} />
                                        </div>
                                    </div>
                                    <div className="col-start-2 col-end-13 pl-2 flex flex-col">
                                        <div className="flex items-center">
                                            <span className="font-medium text-xs text-cs9 uppercase truncate">{e.dateShort} | {e.time} | {desc}</span>
                                        </div>
                                        <span className="font-medium text-xs text-cs-10 truncate">{e.team1}</span>
                                        <span className="font-medium text-xs text-cs-10 truncate">{e.team2}</span>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                )
            )}
        </>
    );
}
